import { Color, IconSize, TextSize, Icon as Icons } from '../types/Theme.types';
import { SearchPageType } from 'search/SearchContext';

type IconAndTextProps = {
    content: string | number;
    iconColor?: Color;
    iconStrokeColor?: Color;
    iconId: Icons;
    /** @default 'true' */
    isInline?: boolean;
    /** @default 'grey-steel' */
    contentColor?: Color;
    size?: IconSize;
    textSize?: TextSize;
    className?: string;
    isBold?: boolean;
    margin?: string;
};

type TransportProps = {
    poiType: Icons;
    distanceInMiles: number;
    title: string;
};

type tags = {
    content: string;
};

type branch = {
    branchDetailsUri: string;
    logoUrl: string;
    name: string;
    phone: string;
};

export type ImageProps = {
    src: string;
    caption: string | null;
    responsiveImgList?: {
        width: number;
        src: string;
    }[];
};

export type SubImage = {
    small: string;
    large: string;
    caption: string;
};

export type SubImageComponent = {
    key: string;
    src: string;
    selected: boolean;
    title: string;
};

type Highlights = {
    description: boolean | string;
    label: string;
    url: boolean | string;
};

export enum DisplayType {
    STANDARD = 'standard',
    PREMIUM_PLUS = 'premium_plus'
}

type ListingType = {
    [key in DisplayType]: string;
};

type ListingUris = {
    contact: string;
    detail: string;
};

type PriceDrop = {
    lastPriceChangeDate: string;
    percentageChangeLabel: string;
};

export enum HaloType {
    PREMIUM,
    FEATURED,
    NONE
}

export type Props = {
    listingId: string;
    flag: string | null;
    image: ImageProps;
    branch: branch;
    numberOfVideos: number;
    numberOfFloorPlans: number;
    numberOfImages: number;
    isHelptoBuy?: boolean;
    priceTitle?: string;
    price: string;
    isPremium: boolean;
    underOffer?: boolean;
    priceDrop?: PriceDrop;
    displayType?: ListingType;
    otherPropertyImages: SubImage[];
    highlights: Highlights[];
    /** props from IconAndText component */
    features: IconAndTextProps[];
    title: string;
    address: string;
    transports: TransportProps[];
    tags: tags[];
    publishedOnLabel: string;
    publishedOn: string;
    numberOfViews: number;
    isFavourite: boolean;
    onSaveClick: () => void;
    contactOnClick?: () => void;
    phoneOnClick?: () => void;
    phoneRevealOnClick?: () => void;
    imageOnClick?: () => void;
    titleOnClick?: () => void;
    priceOnClick?: () => void;
    descriptionOnClick?: () => void;
    specOnClick?: () => void;
    transportInfoOnClick?: () => void;
    cardOnClick?: () => void;
    onCardEcommerceClick?: () => void;
    agentLogoOnClick?: () => void;
    removeFavouriteLabel: string;
    saveFavouriteLabel: string;
    viewsLabel: string;
    viewsPeriodLabel: string;
    listingUris?: ListingUris;
    searchIdentifier?: string;
    availableFrom?: string;
    availableFromLabel?: string;
    searchType?: SearchPageType;
    overrideViewsWithAvailability?: boolean;
    'data-testid'?: string;
    className?: string;
    useLazyImage?: boolean;
    showHalo: boolean;
    presentationType?: string;
    isPhoneClickToRevealEnabled: boolean;
};
